module.exports = {
      id: "icon-video-usage",
      viewBox: "0 0 63.3 63.3",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#icon-video",
      toString: function () {
        return this.url;
      }
    }